// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"18ed01c5","997":"d9291623"}[chunkId] + ".chunk.js";
};